import { collectionFilterConfigs } from '@/constants/filters';
import { Collection } from '@/types/collections';

type FilterConfig = {
  filterString: string;
  tagFilters: string[];
  facetFilters: string[];
  pageHeader: string;
};

export const getCollectionFilterConfig = (collection: Collection): FilterConfig => {
  return collectionFilterConfigs[collection];
};
